import { Divider, Drawer, Input, Space, Slider, Button, Tooltip } from "antd";
import React, { useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import PresetPicker from "../../../globals/styles/PresetPicker";
import BMInput from "../../comps/BMInput";
import { PicRightOutlined, PicLeftOutlined, PicCenterOutlined } from '@ant-design/icons';
import ColourPicker from "../../../globals/styles/ColourPicker";
import { getColor } from "../../../utils/ConvertCSS";
import ButtonPicker from "../../../globals/styles/ButtonPicker";
import balance_input from "../../../media/gift_card_input.png"
import { AlignCenterIcon, AlignLeftIcon, AlignRightIcon, PaddingHorizontalIcon, PaddingVerticalIcon } from "../../Icons";
import { useTemplate } from "../../../utils/Template";
import { tt_gbc_padding_x, tt_gbc_padding_y, tt_gci_gap, tt_name_block_warning } from "../../../utils/Utils";


export default function BalanceChecker(props) {

    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0 } = props;
    const [content, setContent] = useState(props.content);
    const [template,] = useTemplate()

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = false,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        title = "Check your Gift Card balance",
        description = "Type in your Gift Card number (found on the back of the card, right below the barcode) and hit go.",
        width = 800,
        align = "0 auto",
        text_align = "left",
        padding_x = 20,
        padding_y = 20,
        button_type = 0,
        preset = 0,
        description_preset = 0,
        background_colour = 0,
        button_label = "Check",
        gap = 0,
    } = data;

    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const marks = {
        800: <small>800px</small>,
    };

    const drawRender = () => {
        let _gridContainer = {
            maxWidth: width + "px",
            margin: align,
            padding: padding_y + "px " + padding_x + "px",
            textAlign: text_align,

        }
        let bg = {
            background: getColor(background_colour, template),
        }
        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div style={bg}>
                    <div style={_gridContainer}>
                        <h3 className={"bm-txt-" + preset}>{title}</h3>
                        <div className="shim" style={{"height" : gap + "px"}} />
                        <p className={"bm-txt-" + description_preset}>{description}</p>
                        <div><img src={balance_input} /></div>
                        <div className="shim" /><div className="shim" /><div className="shim" />
                        <Button className={"bm-btn-" + button_type}>{button_label}</Button>
                    </div>
                </div>
            </div>
        )
    }

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />
                {/* WIDTH */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">MAX TEXT WIDTH</Divider>
                <Slider
                    // style={{ "width": "150px" }}
                    min={300}
                    max={1248}
                    marks={marks}
                    onChange={(_v) => setData({ ...data, "width": _v })}
                    value={width}
                />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ALIGN / GAP / PADDING</Divider>
                <div className="float-flex">
                    <Space>
                        <div><PicLeftOutlined onClick={() => setData({ ...data, "align": "0" })} style={{ "color": (align === "0") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicCenterOutlined onClick={() => setData({ ...data, "align": "0 auto" })} style={{ "color": (align === "0 auto") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicRightOutlined onClick={() => setData({ ...data, "align": "0 0 0 auto" })} style={{ "color": (align === "0 0 0 auto") ? "#1890ff" : "#AAA" }} /></div>
                    </Space>
                    <Space size={5}>
                        <BMInput width={35} value={gap} onChange={(_v) => setData({ ...data, "gap": _v })} number min={0} max={100} prefix={<Tooltip title={tt_gci_gap}>GAP</Tooltip>} />
                        <BMInput width={35} value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<Tooltip showArrow={false} title={tt_gbc_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        <BMInput width={35} value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<Tooltip showArrow={false} title={tt_gbc_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                    </Space>
                </div>
                <div className="shim" /><div className="shim" />

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT ALIGN</Divider>
                <div className="float-flex">
                    <div>
                        <Space>
                            <div><AlignLeftIcon onClick={() => setData({ ...data, "text_align": "left" })} style={{ "color": (text_align === "left") ? "#1890ff" : "#AAA" }} /></div>
                            <div><AlignCenterIcon onClick={() => setData({ ...data, "text_align": "center" })} style={{ "color": (text_align === "center") ? "#1890ff" : "#AAA" }} /></div>
                            <div><AlignRightIcon onClick={() => setData({ ...data, "text_align": "right" })} style={{ "color": (text_align === "right") ? "#1890ff" : "#AAA" }} /></div>
                        </Space>
                    </div>
                </div>
                <div className="shim" /><div className="shim" />


                <div className="group-wrap">
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADLING PRESET</Divider>
                    <PresetPicker value={preset} onChange={(e) => setData({ ...data, "preset": e })} />
                    <div className="shim" /> <div className="shim" />
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADLINE</Divider>
                    <Input style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "title": e.target.value })} value={title} placeholder="Title..." />
                </div>
                <div className="shim" /> <div className="shim" />

                <div className="group-wrap">
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">DESCRIPTION PRESET</Divider>
                    <PresetPicker value={description_preset} onChange={(e) => setData({ ...data, "description_preset": e })} />
                    <div className="shim" /> <div className="shim" />
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">DESCRIPTION</Divider>
                    <Input.TextArea style={{ "fontSize": "11px" }} value={description} onChange={(e) => setData({ ...data, "description": e.target.value })} rows={5} />
                </div>
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON PRESET</Divider>
                <ButtonPicker value={button_type} onChange={(e) => setData({ ...data, "button_type": e })} />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON LABEL</Divider>
                <Input style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "button_label": e.target.value })} value={button_label} placeholder="Button label..." />
                <div className="shim" /> <div className="shim" />
            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}